import { type KanaType, TypeOfKana } from '../types/kana';

const hiragana: KanaType[] = [
  {
    id: 'h_a',
    pronunciation: 'A',
    kana: 'あ',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'h_i',
    pronunciation: 'I',
    kana: 'い',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'h_u',
    pronunciation: 'U',
    kana: 'う',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'h_e',
    pronunciation: 'E',
    kana: 'え',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'h_o',
    pronunciation: 'O',
    kana: 'お',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'h_ka',
    pronunciation: 'KA',
    kana: 'か',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'h_ki',
    pronunciation: 'KI',
    kana: 'き',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'h_ku',
    pronunciation: 'KU',
    kana: 'く',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'h_ke',
    pronunciation: 'KE',
    kana: 'け',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'h_ko',
    pronunciation: 'KO',
    kana: 'こ',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'h_sa',
    pronunciation: 'SA',
    kana: 'さ',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'h_shi',
    pronunciation: 'SHI',
    kana: 'し',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'h_su',
    pronunciation: 'SU',
    kana: 'す',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'h_se',
    pronunciation: 'SE',
    kana: 'せ',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'h_so',
    pronunciation: 'SO',
    kana: 'そ',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'h_ta',
    pronunciation: 'TA',
    kana: 'た',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'h_chi',
    pronunciation: 'CHI',
    kana: 'ち',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'h_tsu',
    pronunciation: 'TSU',
    kana: 'つ',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'h_te',
    pronunciation: 'TE',
    kana: 'て',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'h_to',
    pronunciation: 'TO',
    kana: 'と',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'h_na',
    pronunciation: 'NA',
    kana: 'な',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'h_ni',
    pronunciation: 'NI',
    kana: 'に',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'h_nu',
    pronunciation: 'NU',
    kana: 'ぬ',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'h_ne',
    pronunciation: 'NE',
    kana: 'ね',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'h_no',
    pronunciation: 'NO',
    kana: 'の',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'h_ha',
    pronunciation: 'HA',
    kana: 'は',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'h_hi',
    pronunciation: 'HI',
    kana: 'ひ',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'h_fu',
    pronunciation: 'FU',
    kana: 'ふ',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'h_he',
    pronunciation: 'HE',
    kana: 'へ',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'h_ho',
    pronunciation: 'HO',
    kana: 'ほ',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'h_ma',
    pronunciation: 'MA',
    kana: 'ま',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'h_mi',
    pronunciation: 'MI',
    kana: 'み',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'h_mu',
    pronunciation: 'MU',
    kana: 'む',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'h_me',
    pronunciation: 'ME',
    kana: 'め',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'h_mo',
    pronunciation: 'MO',
    kana: 'も',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'h_ya',
    pronunciation: 'YA',
    kana: 'や',
    type: TypeOfKana.basic,
    group: 'y',
  },
  {
    id: 'h_yu',
    pronunciation: 'YU',
    kana: 'ゆ',
    type: TypeOfKana.basic,
    group: 'y',
  },
  {
    id: 'h_yo',
    pronunciation: 'YO',
    kana: 'よ',
    type: TypeOfKana.basic,
    group: 'y',
  },
  {
    id: 'h_ra',
    pronunciation: 'RA',
    kana: 'ら',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'h_ri',
    pronunciation: 'RI',
    kana: 'り',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'h_ru',
    pronunciation: 'RU',
    kana: 'る',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'h_re',
    pronunciation: 'RE',
    kana: 'れ',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'h_ro',
    pronunciation: 'RO',
    kana: 'ろ',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'h_wa',
    pronunciation: 'WA',
    kana: 'わ',
    type: TypeOfKana.basic,
    group: 'w',
  },
  {
    id: 'h_wo',
    pronunciation: '(W)O',
    kana: 'を',
    type: TypeOfKana.basic,
    group: 'w',
  },
  {
    id: 'h_n',
    pronunciation: 'N',
    kana: 'ん',
    type: TypeOfKana.basic,
    group: 'n/m',
  },
  {
    id: 'h_ga',
    pronunciation: 'GA',
    kana: 'が',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'h_gi',
    pronunciation: 'GI',
    kana: 'ぎ',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'h_gu',
    pronunciation: 'GU',
    kana: 'ぐ',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'h_ge',
    pronunciation: 'GE',
    kana: 'げ',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'h_go',
    pronunciation: 'GO',
    kana: 'ご',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'h_za',
    pronunciation: 'ZA',
    kana: 'ざ',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'h_zi',
    pronunciation: 'JI',
    kana: 'じ',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'h_zu',
    pronunciation: 'ZU',
    kana: 'ず',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'h_ze',
    pronunciation: 'ZE',
    kana: 'ぜ',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'h_zo',
    pronunciation: 'ZO',
    kana: 'ぞ',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'h_da',
    pronunciation: 'DA',
    kana: 'だ',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'h_di',
    pronunciation: 'DI',
    kana: 'ぢ',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'h_du',
    pronunciation: 'DSU',
    kana: 'づ',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'h_de',
    pronunciation: 'DE',
    kana: 'で',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'h_do',
    pronunciation: 'DO',
    kana: 'ど',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'h_ba',
    pronunciation: 'BA',
    kana: 'ば',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'h_bi',
    pronunciation: 'BI',
    kana: 'び',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'h_bu',
    pronunciation: 'BU',
    kana: 'ぶ',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'h_be',
    pronunciation: 'BE',
    kana: 'べ',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'h_bo',
    pronunciation: 'BO',
    kana: 'ぼ',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'h_pa',
    pronunciation: 'PA',
    kana: 'ぱ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'h_pi',
    pronunciation: 'PI',
    kana: 'ぴ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'h_pu',
    pronunciation: 'PU',
    kana: 'ぷ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'h_pe',
    pronunciation: 'PE',
    kana: 'ぺ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'h_po',
    pronunciation: 'PO',
    kana: 'ぽ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'h_kya',
    pronunciation: 'KYA',
    kana: 'きゃ',
    type: TypeOfKana.yoon,
    group: 'ky',
  },
  {
    id: 'h_kyu',
    pronunciation: 'KYU',
    kana: 'きゅ',
    type: TypeOfKana.yoon,
    group: 'ky',
  },
  {
    id: 'h_kyo',
    pronunciation: 'KYO',
    kana: 'きょ',
    type: TypeOfKana.yoon,
    group: 'ky',
  },
  {
    id: 'h_sha',
    pronunciation: 'SHA',
    kana: 'しゃ',
    type: TypeOfKana.yoon,
    group: 'sh',
  },
  {
    id: 'h_shu',
    pronunciation: 'SHU',
    kana: 'しゅ',
    type: TypeOfKana.yoon,
    group: 'sh',
  },
  {
    id: 'h_sho',
    pronunciation: 'SHO',
    kana: 'しょ',
    type: TypeOfKana.yoon,
    group: 'sh',
  },
  {
    id: 'h_cha',
    pronunciation: 'CHA',
    kana: 'ちゃ',
    type: TypeOfKana.yoon,
    group: 'ch',
  },
  {
    id: 'h_chu',
    pronunciation: 'CHU',
    kana: 'ちゅ',
    type: TypeOfKana.yoon,
    group: 'ch',
  },
  {
    id: 'h_cho',
    pronunciation: 'CHO',
    kana: 'ちょ',
    type: TypeOfKana.yoon,
    group: 'ch',
  },
  {
    id: 'h_nya',
    pronunciation: 'NYA',
    kana: 'にゃ',
    type: TypeOfKana.yoon,
    group: 'ny',
  },
  {
    id: 'h_nyu',
    pronunciation: 'NYU',
    kana: 'にゅ',
    type: TypeOfKana.yoon,
    group: 'ny',
  },
  {
    id: 'h_nyo',
    pronunciation: 'NYO',
    kana: 'にょ',
    type: TypeOfKana.yoon,
    group: 'ny',
  },
  {
    id: 'h_hya',
    pronunciation: 'HYA',
    kana: 'ひゃ',
    type: TypeOfKana.yoon,
    group: 'hy',
  },
  {
    id: 'h_hyu',
    pronunciation: 'HYU',
    kana: 'ひゅ',
    type: TypeOfKana.yoon,
    group: 'hy',
  },
  {
    id: 'h_hyo',
    pronunciation: 'HYO',
    kana: 'ひょ',
    type: TypeOfKana.yoon,
    group: 'hy',
  },
  {
    id: 'h_mya',
    pronunciation: 'MYA',
    kana: 'みゃ',
    type: TypeOfKana.yoon,
    group: 'my',
  },
  {
    id: 'h_myu',
    pronunciation: 'MYU',
    kana: 'みゅ',
    type: TypeOfKana.yoon,
    group: 'my',
  },
  {
    id: 'h_myo',
    pronunciation: 'MYO',
    kana: 'みょ',
    type: TypeOfKana.yoon,
    group: 'my',
  },
  {
    id: 'h_rya',
    pronunciation: 'RYA',
    kana: 'りゃ',
    type: TypeOfKana.yoon,
    group: 'ry',
  },
  {
    id: 'h_ryu',
    pronunciation: 'RYU',
    kana: 'りゅ',
    type: TypeOfKana.yoon,
    group: 'ry',
  },
  {
    id: 'h_ryo',
    pronunciation: 'RYO',
    kana: 'りょ',
    type: TypeOfKana.yoon,
    group: 'ry',
  },
  {
    id: 'h_gya',
    pronunciation: 'GYA',
    kana: 'ぎゃ',
    type: TypeOfKana.yoon,
    group: 'gy',
  },
  {
    id: 'h_gyu',
    pronunciation: 'GYU',
    kana: 'ぎゅ',
    type: TypeOfKana.yoon,
    group: 'gy',
  },
  {
    id: 'h_gyo',
    pronunciation: 'GYO',
    kana: 'ぎょ',
    type: TypeOfKana.yoon,
    group: 'gy',
  },
  {
    id: 'h_ja',
    pronunciation: 'JA',
    kana: 'じゃ',
    type: TypeOfKana.yoon,
    group: 'j',
  },
  {
    id: 'h_ju',
    pronunciation: 'JU',
    kana: 'じゅ',
    type: TypeOfKana.yoon,
    group: 'j',
  },
  {
    id: 'h_jo',
    pronunciation: 'JO',
    kana: 'じょ',
    type: TypeOfKana.yoon,
    group: 'j',
  },
  {
    id: 'h_bya',
    pronunciation: 'BYA',
    kana: 'びゃ',
    type: TypeOfKana.yoon,
    group: 'by',
  },
  {
    id: 'h_byu',
    pronunciation: 'BYU',
    kana: 'びゅ',
    type: TypeOfKana.yoon,
    group: 'by',
  },
  {
    id: 'h_byo',
    pronunciation: 'BYO',
    kana: 'びょ',
    type: TypeOfKana.yoon,
    group: 'by',
  },
  {
    id: 'h_pya',
    pronunciation: 'PYA',
    kana: 'ぴゃ',
    type: TypeOfKana.yoon,
    group: 'py',
  },
  {
    id: 'h_pyu',
    pronunciation: 'PYU',
    kana: 'ぴゅ',
    type: TypeOfKana.yoon,
    group: 'py',
  },
  {
    id: 'h_pyo',
    pronunciation: 'PYO',
    kana: 'ぴょ',
    type: TypeOfKana.yoon,
    group: 'py',
  },
];

export default hiragana;
